import { render, staticRenderFns } from "./MessDetail.vue?vue&type=template&id=50fb0749&scoped=true&"
import script from "./MessDetail.vue?vue&type=script&lang=js&"
export * from "./MessDetail.vue?vue&type=script&lang=js&"
import style0 from "./MessDetail.vue?vue&type=style&index=0&id=50fb0749&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50fb0749",
  null
  
)

export default component.exports